/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useAwsOnboardingTemplateQuery } from "~/generated/graphql";

export function useGetAwsOnboardingTemplate() {
  const { data, error } = useAwsOnboardingTemplateQuery();
  return { awsOnboardingTemplate: data?.awsOnboardingTemplate, error } as const;
}
